export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false
};
export const PageName = '内部划转配置';